<template>
    <div class="carousel-slider-item glide__slide" v-for="( item, item_id) in blog_list" :key="item_id">
        <ItemBlog :item="item"></ItemBlog>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import ItemBlog from "./ItemBlog.vue";
    const props = defineProps(["data"]);
    const blog_list = computed(() => props.data || []);
</script>

